import { checkAxiosResponse } from '@mst-fe/shared';
import axios from 'axios';

import { axiosOptions } from '../../services/requests';

export type SectionedHighlight = {
  sectionId: string;
  title: string;
  level: string;
  texts: string[];
};

export interface SearchResult {
  id: string;
  title: string;
  highlights?: string[] | SectionedHighlight[];
  contentType?: string;
  metadata?: {
    sourceType?: 'fs' | 'fx' | 'springboards' | 'normalization' | 'data_lake_schema' | 'user_feeds';
    fileName: string;
    filePath: string;
  };
}

export interface ResultsFromSource {
  label: string;
  searchResults: SearchResult[];
}

export class SearchApi {
  async getAllOptionsForTerm(term: string): Promise<ResultsFromSource[] | undefined> {
    return await checkAxiosResponse(axios.get<ResultsFromSource[]>(`/api/zoe/search?term=${term}`, axiosOptions()));
  }

  async getOptionsForTerm(providerName: string, term: string): Promise<ResultsFromSource | undefined> {
    return await checkAxiosResponse(axios.get<ResultsFromSource>(`/api/zoe/search/${providerName}?term=${term}`, axiosOptions()));
  }
}
